// extracted by mini-css-extract-plugin
export var active = "_6c-a";
export var activeIndicator = "_6c-9";
export var disabled = "_6c-b";
export var fullWidth = "_6c-2";
export var lg = "_6c-7";
export var md = "_6c-6";
export var redoButtonTabGroup = "_6c-0";
export var sm = "_6c-5";
export var tabButton = "_6c-4";
export var tabButtonsContainer = "_6c-1";
export var themeDestructive = "_6c-d";
export var themeNormal = "_6c-c";
export var themeSuccess = "_6c-e";
export var xl = "_6c-8";
export var xs = "_6c-3";